import React from 'react';
import PropTypes from 'prop-types';
import s from './CricketRecordWidget.scss';

const CricketRecordWidget = props => {
  const { title, label1, label2 } = props;
  return (
    <>
      <div className={`${s.highlighted} ${s.recordsColumn}`}>{title}</div>
      <div className={`${s.vs_score} ${s.recordsColumn}`}>
        <div className={s.scoreData}>
          <div className={s.score}>{label1}</div>
          <div>{label2}</div>
        </div>
      </div>
    </>
  );
};
CricketRecordWidget.propTypes = {
  title: PropTypes.string,
  label1: PropTypes.string,
  label2: PropTypes.string,
};
CricketRecordWidget.defaultProps = {
  title: '',
  label1: '',
  label2: '',
};
export default CricketRecordWidget;
